import { render, staticRenderFns } from "./selectClass.vue?vue&type=template&id=d1f58b26&scoped=true&"
import script from "./selectClass.vue?vue&type=script&lang=js&"
export * from "./selectClass.vue?vue&type=script&lang=js&"
import style0 from "./selectClass.vue?vue&type=style&index=0&id=d1f58b26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f58b26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1f58b26')) {
      api.createRecord('d1f58b26', component.options)
    } else {
      api.reload('d1f58b26', component.options)
    }
    module.hot.accept("./selectClass.vue?vue&type=template&id=d1f58b26&scoped=true&", function () {
      api.rerender('d1f58b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/selectClass.vue"
export default component.exports